export const SIGN_IN_VIEW_CREDENTIALS_FORM_FIELDS = {
  Email: 'email',
  Password: 'password',
} as const;

export type SignInViewCredentialsFormValues = {
  [SIGN_IN_VIEW_CREDENTIALS_FORM_FIELDS.Email]: string;
  [SIGN_IN_VIEW_CREDENTIALS_FORM_FIELDS.Password]: string;
};
